import { Container, styled } from "@mui/material";

export const LayoutWrapper = styled(Container)(() => {
    return {
        padding: 0,
    }
})